import { createSlice } from '@reduxjs/toolkit';

const iqmsSlice = createSlice({
  name: 'iqms',
  initialState: {
    processes: [],
    audits: [],
    capas: [],
    risks: [],
    selectedProcess: null,
    selectedAudit: null,
    selectedCapa: null,
    selectedRisk: null,
    isLoading: false,
    error: null,
    stats: {
      totalProcesses: 0,
      totalAudits: 0,
      openCapas: 0,
      activeRisks: 0,
    },
  },
  reducers: {
    setProcesses(state, action) {
      state.processes = action.payload;
    },
    setAudits(state, action) {
      state.audits = action.payload;
    },
    setCapas(state, action) {
      state.capas = action.payload;
    },
    setRisks(state, action) {
      state.risks = action.payload;
    },
    setSelectedProcess(state, action) {
      state.selectedProcess = action.payload;
    },
    setSelectedAudit(state, action) {
      state.selectedAudit = action.payload;
    },
    setSelectedCapa(state, action) {
      state.selectedCapa = action.payload;
    },
    setSelectedRisk(state, action) {
      state.selectedRisk = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStats(state, action) {
      state.stats = { ...state.stats, ...action.payload };
    },
    addProcess(state, action) {
      state.processes.push(action.payload);
    },
    updateProcess(state, action) {
      const index = state.processes.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.processes[index] = action.payload;
      }
    },
    removeProcess(state, action) {
      state.processes = state.processes.filter(p => p.id !== action.payload);
    },
    addAudit(state, action) {
      state.audits.push(action.payload);
    },
    updateAudit(state, action) {
      const index = state.audits.findIndex(a => a.id === action.payload.id);
      if (index !== -1) {
        state.audits[index] = action.payload;
      }
    },
    removeAudit(state, action) {
      state.audits = state.audits.filter(a => a.id !== action.payload);
    },
    addCapa(state, action) {
      state.capas.push(action.payload);
    },
    updateCapa(state, action) {
      const index = state.capas.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.capas[index] = action.payload;
      }
    },
    removeCapa(state, action) {
      state.capas = state.capas.filter(c => c.id !== action.payload);
    },
    addRisk(state, action) {
      state.risks.push(action.payload);
    },
    updateRisk(state, action) {
      const index = state.risks.findIndex(r => r.id === action.payload.id);
      if (index !== -1) {
        state.risks[index] = action.payload;
      }
    },
    removeRisk(state, action) {
      state.risks = state.risks.filter(r => r.id !== action.payload);
    },
    clearIqmsState(state) {
      state.processes = [];
      state.audits = [];
      state.capas = [];
      state.risks = [];
      state.selectedProcess = null;
      state.selectedAudit = null;
      state.selectedCapa = null;
      state.selectedRisk = null;
      state.error = null;
    },
  },
});

export const iqmsActions = iqmsSlice.actions;

export default iqmsSlice;

